export default "__VITE_ASSET__DbwvGK66__"